module.exports = __webpack_public_path__ + "img/background-login.03ca495b.jpg";